import { sortByDate } from "@utils/sorters";
import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";
import { isAfter, isBefore, parse } from "date-fns";
import { formatDate, formatTime } from "@utils/dates";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authenticatedApi } from "api";

const endpoint:string = 'imports';

export function useGetAllImports(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetImport(id: number, params:any = {}) {
    return useGetOne({
        queryKey: [endpoint, id],
        refetchInterval: (query) => {
            return !query.state.data || ['processing', 'queued'].indexOf(query.state.data.status) !== -1 ? 5000 : undefined;
        },
        ...params,
    });
}

export function useCreateImport() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateImport({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteImport({id}) {
    return useDelete({queryKey: [endpoint, id]});
}

export function useRetryImport({id}) {
    const queryClient = useQueryClient();

    // When this mutation succeeds, invalidate any import queries
    return useMutation({
        mutationFn: async () => {
            const { data } = await authenticatedApi.post(`/${endpoint}/${id}/retry`);
            return data;//data.hasOwnProperty('data') ? data.data : data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [endpoint] })
        },
    })
}

export const importTypes = {
    contacts: 'Contacts',
    businesses: 'Businesses',
    properties: 'Properties',
    workplans: 'Work Plan',
};

export const importStatuses = {
    completed: 'Completed',
    failed: 'Failed',
    processing: 'Processing',
    queued: 'Queued',
    canceled: 'Canceled',
    action: 'Action Required',
    initial: 'Not complete (unsaved)',
};


export function tallySkipped(row) {
    if(!row.statistics.hasOwnProperty('skipped') || !Object.keys(row.statistics.skipped).length)
    {
        return 0;
    }

    var total = 0;
    for(let failedIterator in row.statistics.skipped)
    {
        total += row.statistics.skipped[failedIterator].length;
    }

    return total;
};
